import Phaser from 'phaser';
import { CST } from '../CST';

export default class Popup extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.POPUP);
	}

	create() {
		this.bg = this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'loading-bg',
		);
		this.popup = this.add.image(
			this.cameras.main.width / 2,
			this.cameras.main.height / 2,
			'desktop-bg',
		);
		this.nextBtn = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 300, 'next-btn')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () => {
				this.scene.start(CST.SCENES.MENU);
			});
	}
}
